import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDBoxes_Form_Manuel_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDBoxes_Form_Manuel_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  SelectSTDBoxes: any[];
  SelectSTDBoxes_dummy: any[];
  SelectStdproductsForProductid: any[];
  SelectStdproductsForProductid_dummy: any[];
  GetStationInfo: any[];
  GetStationInfo_dummy: any[];
  GetProductDetail: any[];
  GetProductDetail_dummy: any[];
  GetLabelWithBoxId: any[];
  GetLabelWithBoxId_dummy: any[];
  GetBoxType: any[];
  GetBoxType_dummy: any[];
  GetCustomerProductInfos: any[];
  GetCustomerProductInfos_dummy: any[];
  ChangeEnabledOf: any;
  ChangeEnabledOf_dummy: any;
  STDCustomerProductsSave: number;
  STDCustomerProductsSave_dummy: number;
  GetSameProductCount: any[];
  GetSameProductCount_dummy: any[];
  DeleteEtiketForAddedManuelBox: number;
  DeleteEtiketForAddedManuelBox_dummy: number;
  UpdateBoxCount: number;
  UpdateBoxCount_dummy: number;
  STDBoxesSave: number;
  STDBoxesSave_dummy: number;
  GetNewBoxIdent: any[];
  GetNewBoxIdent_dummy: any[];
  GenerateExactLabel: string;
  GenerateExactLabel_dummy: string;
  StringForLabelName: string;
  StringForLabelName_dummy: string;
  STDEtiketSave: number;
  STDEtiketSave_dummy: number;
  isComp865868Enabled: "enabled" | "disabled";
  isComp804937Enabled: "enabled" | "disabled";
}

export class STDBoxes_Form_Manuel_ScreenBase extends React.PureComponent<
  ISTDBoxes_Form_Manuel_ScreenProps,
  any
> {
  stdboxes_form_manuel_880268_value_kuikaAutoCompleteRef: React.RefObject<any>;
  stdboxes_form_manuel_874246_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "ddb2b834-ebe6-4dc8-ab83-96051ddf33d9",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 428726, PropertyName: "value", Value: "KLT - Kutu  Form" },
        { Id: 199963, PropertyName: "value", Value: "İstasyon" },
        { Id: 606034, PropertyName: "value", Value: "Malzeme " },
        { Id: 880268, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 972129, PropertyName: "value", Value: "Müşteri Malzeme Kodu" },
        { Id: 865868, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 517781, PropertyName: "value", Value: "Müşteri Malzeme Tanımı" },
        { Id: 804937, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 156988, PropertyName: "value", Value: "Kutu Tipi" },
        { Id: 874246, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 628129, PropertyName: "value", Value: "İçerik Adet" },
        { Id: 994812, PropertyName: "placeholder", Value: "15" },
        { Id: 192300, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdboxes_form_manuel_880268_value_kuikaAutoCompleteRef =
      React.createRef();
    this.stdboxes_form_manuel_865868_value_kuikaTextInputRef =
      React.createRef();
    this.stdboxes_form_manuel_804937_value_kuikaTextInputRef =
      React.createRef();
    this.stdboxes_form_manuel_874246_value_kuikaSelectBoxRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      SelectSTDBoxes: [],
      SelectStdproductsForProductid: [],
      GetStationInfo: [],
      GetProductDetail: [],
      GetLabelWithBoxId: [],
      GetBoxType: [],
      GetCustomerProductInfos: [],
      dataSource_874246: [
        { key: "3215", text: "3215" },
        { key: "4315", text: "4315" },
        { key: "Kanban Ek", text: "Kanban Ek" },
      ],
      isComp865868Enabled: "disabled",
      isComp804937Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdboxes_form_manuel", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDBoxes_Form_ManuelPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdboxes_form_manuel", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdboxes_form_manuel", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDBoxes_Form_ManuelPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdboxes_form_manuel_880268_value:
        this.state.SelectSTDBoxes?.at?.(0)?.productId ?? undefined,
      stdboxes_form_manuel_865868_value:
        this.state.GetCustomerProductInfos?.at?.(0)?.productCode ?? undefined,
      stdboxes_form_manuel_804937_value:
        this.state.GetCustomerProductInfos?.at?.(0)?.productName ?? undefined,
      stdboxes_form_manuel_994812_value: undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDBoxes_Form_ManuelPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_Form_ManuelPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDBoxes_Form_Manuel",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxCreate
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDBoxes_Form_ManuelPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_Form_ManuelPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDBoxes = result?.data.selectSTDBoxes;
    formVars.stdboxes_form_manuel_880268_value =
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null;
    formVars.stdboxes_form_manuel_880268_options =
      stateVars.SelectStdproductsForProductid;
    stateVars.SelectStdproductsForProductid =
      result?.data.selectStdproductsForProductid;

    formVars.stdboxes_form_manuel_880268_value =
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null;
    formVars.stdboxes_form_manuel_880268_options =
      stateVars.SelectStdproductsForProductid;
    stateVars.GetStationInfo = result?.data.getStationInfo;
    formVars.stdboxes_form_manuel_118875_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationInfo !== undefined
        ? stateVars.GetStationInfo?.length > 0
          ? stateVars.GetStationInfo[0].stationName
          : null
        : this.state.GetStationInfo?.length > 0
        ? this.state.GetStationInfo[0].stationName
        : null
    );
    stateVars.GetProductDetail = result?.data.getProductDetail;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.GetBoxType = result?.data.getBoxType;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_Form_ManuelPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdboxes_form_manuel_118875_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationInfo !== undefined
        ? stateVars.GetStationInfo?.length > 0
          ? stateVars.GetStationInfo[0].stationName
          : null
        : this.state.GetStationInfo?.length > 0
        ? this.state.GetStationInfo[0].stationName
        : null
    );

    formVars.stdboxes_form_manuel_880268_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null
    );

    stateVars.dataSource_880268 =
      stateVars.SelectStdproductsForProductid ??
      this.state.SelectStdproductsForProductid;
    stateVars.dataSource_880268 =
      stateVars.SelectStdproductsForProductid ??
      this.state.SelectStdproductsForProductid;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_880268_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].customerId
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].customerId
            : null
        ),
        "Guid"
      ),
      StdProductCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelComponent_880268_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductDetail = result?.data.getProductDetail;
    stateVars.GetCustomerProductInfos = result?.data.getCustomerProductInfos;
    formVars.stdboxes_form_manuel_865868_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productCode
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productCode
        : null
    );
    formVars.stdboxes_form_manuel_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productName
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productName
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_880268_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_880268_onChange_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName("isComp865868Enabled", "string"),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );
    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName("isComp804937Enabled", "string"),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_880268_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCustomerProductInfos !== undefined
            ? stateVars.GetCustomerProductInfos?.length > 0
              ? stateVars.GetCustomerProductInfos[0].id
              : null
            : this.state.GetCustomerProductInfos?.length > 0
            ? this.state.GetCustomerProductInfos[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_Form_ManuelComponent_880268_onChange_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    formVars.stdboxes_form_manuel_865868_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productCode
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productCode
        : null
    );

    formVars.stdboxes_form_manuel_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productName
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productName
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_192300_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].customerId
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].customerId
            : null
        ),
        "Guid"
      ),
      StdProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelComponent_192300_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCustomerProductInfos = result?.data.getCustomerProductInfos;
    formVars.stdboxes_form_manuel_865868_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productCode
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productCode
        : null
    );
    formVars.stdboxes_form_manuel_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productName
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productName
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_192300_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_192300_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].customerId
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].customerId
            : null
        ),
        "Guid"
      ),
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StdProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      UpdatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      UpdatedBy_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelComponent_192300_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDCustomerProductsSave = result?.data.stdCustomerProductsSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_192300_onClick_if11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_192300_onClick_if1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_874246_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_874246_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_994812_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_994812_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CustomerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].expectedQuantity
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].expectedQuantity
            : null
        ),
        "string"
      ),
      barcodeValue_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxType
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxType
            : null
        ),
        "string"
      ),
      labelType_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelComponent_192300_onClick_if1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSameProductCount = result?.data.getSameProductCount;
    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_192300_onClick_if1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_192300_onClick_if1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_192300_onClick_if1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_874246_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_874246_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_994812_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_994812_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].expectedQuantity
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].expectedQuantity
            : null
        ),
        "string"
      ),
      barcodeValue_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxType
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxType
            : null
        ),
        "string"
      ),
      labelType_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelComponent_192300_onClick_if1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_192300_onClick_if1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_192300_onClick_if1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_192300_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_Form_ManuelComponent_192300_onClick_if1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_Form_ManuelComponent_192300_onClick_if1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_192300_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_192300_onClick_else11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_192300_onClick_else1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_874246_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_874246_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_994812_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_994812_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CustomerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].expectedQuantity
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].expectedQuantity
            : null
        ),
        "string"
      ),
      barcodeValue_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxType
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxType
            : null
        ),
        "string"
      ),
      labelType_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelComponent_192300_onClick_else1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSameProductCount = result?.data.getSameProductCount;
    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_192300_onClick_else1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_192300_onClick_else1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_192300_onClick_else1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_874246_value",
          "value",
          "",
          "key",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_874246_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_manuel_994812_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_manuel_994812_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].expectedQuantity
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].expectedQuantity
            : null
        ),
        "string"
      ),
      barcodeValue_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxType
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxType
            : null
        ),
        "string"
      ),
      labelType_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetNewBoxIdent !== undefined
            ? stateVars.GetNewBoxIdent?.length > 0
              ? stateVars.GetNewBoxIdent[0].boxIdentifier
              : null
            : this.state.GetNewBoxIdent?.length > 0
            ? this.state.GetNewBoxIdent[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form_Manuel/STDBoxes_Form_ManuelComponent_192300_onClick_else1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_Form_ManuelComponent_192300_onClick_else1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_Form_ManuelComponent_192300_onClick_else1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_192300_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_manuel_874246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_Form_ManuelComponent_192300_onClick_else1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_Form_ManuelComponent_192300_onClick_else1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_Form_ManuelComponent_192300_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCustomerProductInfos !== undefined
            ? stateVars.GetCustomerProductInfos?.length > 0
              ? stateVars.GetCustomerProductInfos[0].id
              : null
            : this.state.GetCustomerProductInfos?.length > 0
            ? this.state.GetCustomerProductInfos[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_Form_ManuelComponent_192300_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_Form_ManuelComponent_192300_onClick_else1();
      if (isErrorOccurred) return true;
    }

    formVars.stdboxes_form_manuel_865868_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productCode
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productCode
        : null
    );

    formVars.stdboxes_form_manuel_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerProductInfos !== undefined
        ? stateVars.GetCustomerProductInfos?.length > 0
          ? stateVars.GetCustomerProductInfos[0].productName
          : null
        : this.state.GetCustomerProductInfos?.length > 0
        ? this.state.GetCustomerProductInfos[0].productName
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDBoxes_Form_Manuel"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDBoxes_Form_ManuelPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDBoxes_Form_ManuelPageInit();
    }
  }
}
